<template>
  <transition name="n-modal">
    <div class="n-modal-mask">
      <div
        :class="{ 'n-modal-wrapper': true, lightbox: lightbox }"
        @click.self="onClose"
        v-closeOnOutsideClick="{ active: 'lightbox', handler: 'onClose' }"
      >
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-title"
          :class="{ 'n-modal-container': true, closeable: closeable }"
          :style="{ width: trueWidth, maxWidth: trueMaxWidth }"
        >
          <a
            class="close-button"
            v-if="closeable"
            @click.prevent="onClose"
            href=""
            aria-label="Close"
          >
            <svg
              class="close"
              data-v-20f4c42f=""
              width="18px"
              height="17px"
              viewBox="0 0 18 17"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g stroke="none" stroke-width="1">
                <path
                  d="M8.99734389,7.08578644 L16.0684117,0.0147186258 L17.4826253,1.42893219 L10.4115575,8.5 L17.5536931,15.6421356 L16.1394795,17.0563492 L8.99734389,9.91421356 L1.92627608,16.9852814 L0.512062518,15.5710678 L7.58313033,8.5 L0.58313033,1.5 L1.99734389,0.0857864376 L8.99734389,7.08578644 Z"
                ></path>
              </g>
            </svg>
          </a>
          <div class="n-modal-content">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="less" scoped>
.n-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.n-modal-wrapper {
  padding: 30px 0;
  overflow: auto;
  max-height: 100vh;
  width: 100%;
  scroll-behavior: smooth;
}

.n-modal-container {
  position: relative;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  text-align: left;
  box-sizing: border-box;
  border: 1px solid transparent;
}

.close-button {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 9999px;
  display: block;
  height: 30px;
  width: 30px;
  position: absolute;
  right: 12px;
  top: 12px;
  text-align: center;
  line-height: 33px;
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.8);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  .close {
    margin: 0;
    color: #aaa;
    fill: #aaa;
    font-size: 1.3em;
    width: 15px;
    height: 15px;
  }

  &:hover,
  &:focus {
    .close {
      color: #888;
      fill: #888;
    }
  }
}

.n-modal-content {
  padding: 40px;

  // Won't apply as scoped
  // h3 {
  //   font-weight: bold;
  //   color: #000;
  //   margin-top: 20px;
  // }

  // p {
  //   padding-bottom: 1.25em;
  //   color: #000;
  //   a {
  //     color: #000;
  //     text-decoration: underline;
  //   }
  // }
  // .lp-btn {
  //   display: inline-block;
  //   width: auto;
  //   margin-top: 30px;
  // }
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.n-modal-enter {
  opacity: 0;
}

.n-modal-leave-active {
  opacity: 0;
}

.n-modal-enter .n-modal-container,
.n-modal-leave-active .n-modal-container {
  -webkit-transform: scale(0.85);
  transform: scale(0.85);
}

.lightbox {
  background-color: rgba(0, 0, 0, 0.8);
}

@media (max-width: 700px) {
  .n-modal-wrapper {
    padding: 0;
  }

  .n-modal-container {
    border-radius: 0 !important;
    position: relative;
  }

  .n-modal-content {
    padding: 12px;
  }

  .close-button {
    right: 18px;
    top: 18px;
    position: fixed;
    background: rgba(33, 33, 33, 0.6);


    .close{
      color: #ccc;
      fill: #ccc;
    }
    &:hover{
      svg{
        color: #FFF;
        fill: #FFF;
      }
    }
  }
}
</style>

<script>
import jQuery from "jquery";
import { closeOnOutsideClick } from "@/common/directives/closeOnOutsideClick";
export default {
  props: {
    lightbox: {
      type: Boolean,
      default: false,
    },
    closeable: {
      type: Boolean,
      default: true,
    },
    width: {
      default: "",
    },
    maxWidth: {
      default: "95vw",
    },
  },
  data() {
    return {
      mediaListener: null,
      mobileView: false,
    };
  },
  computed: {
    trueWidth() {
      return this.mobileView ? "100%" : this.width;
    },
    trueMaxWidth() {
      return this.mobileView ? "unset" : this.maxWidth;
    },
  },
  directives: {
    closeOnOutsideClick: closeOnOutsideClick,
  },
  mounted() {
    document.addEventListener("keydown", this.closeOnEscape);
    this.initWidthTracking();
    const scrollbarWidth =
      jQuery(window).outerWidth(true) - jQuery("body").outerWidth(true);
    jQuery("body").css({
      overflow: "hidden",
      paddingRight: scrollbarWidth + "px",
    });
  },
  methods: {
    onClose(el) {
      this.$emit("dismiss");
    },
    closeOnEscape(e) {
      if (e.keyCode == 27) {
        this.onClose();
      }
    },
    initWidthTracking() {
      let listener = (mq) => {
        this.mobileView = mq.matches;
      };
      let mq = window.matchMedia(`(max-width: 700px)`);
      listener(mq);
      mq.addEventListener("change", listener);
      this.mediaListener = { mq, listener };
    },
    destroyWidthTracking() {
      if (this.mediaListener) {
        this.mediaListener.mq.removeEventListener(
          "change",
          this.mediaListener.listener
        );
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.closeOnEscape);
    this.destroyWidthTracking();
    jQuery("body").css({ overflow: "", paddingRight: "" });
  },
};
</script>
